import React from 'react'
import { Row, Col } from "antd";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import SurfaceLogo from '../../assets/images/surface-logo.png'
export default function rmxFooter({ storeName, ...props }) {
    return (
        <Row justify="end">
            <Col span={24} id="container">
                <Row align="middle" justify="space-between">
                    <Col
                        xl={2}
                        lg={2}
                        md={4}
                        xs={2}
                        sm={2}
                        style={{
                            paddingLeft: !!Object.keys(storeName)
                                ?.length
                                ? "100px"
                                : "20px",
                        }}
                    >
                        <img src={SurfaceLogo} height="20px" />
                    </Col>
                    {!Object.keys(storeName)?.length && (
                        <Col xl={20} lg={20} md={24} xs={24} sm={24} >
                            <Row align="middle" justify="center">
                                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                                    <a
                                        href="https://www.surface-tech.com/about-m/"
                                        target="_blank"
                                    >
                                        <h4
                                            className="color-white nav-font-bold "
                                            style={{ color: "#fff" }}
                                        >
                                            HOME
                                        </h4>
                                    </a>
                                </Col>
                                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                                    <a
                                        href="https://www.surface-tech.com/asphalt-overview-2/"
                                        target="_blank"
                                    >
                                        <h4 className="color-white nav-font-bold ">
                                            ABOUT
                                        </h4>
                                    </a>
                                </Col>
                                <Col xl={2} xs={7} sm={6} md={4} lg={4}>
                                    <a
                                        href="https://www.surface-tech.com/concrete_platform_2017/"
                                        target="_blank"
                                    >
                                        <h4 className="color-white nav-font-bold ">
                                            TECHNOLOGY
                                        </h4>
                                    </a>
                                </Col>
                                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                                    <a
                                        href="https://surface-tech.com/trkr-overview/"
                                        target="_blank"
                                    >
                                        <h4 className="color-white nav-font-bold ">
                                            NEWS
                                        </h4>
                                    </a>
                                </Col>
                                <Col xl={2} xs={6} sm={6} md={4} lg={2}>
                                    <a
                                        href="https://www.surface-tech.com/contact-2017/"
                                        target="_blank"
                                    >
                                        <h4 className="color-white nav-font-bold ">
                                            CONTACT
                                        </h4>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                    )}
                    <Col
                        xl={!Object.keys(storeName)?.length ? 2 : 4}
                        lg={2}
                        md={24}
                        xs={24}
                        sm={24}
                        style={{
                            paddingRight: !!Object.keys(storeName)?.length
                                ? "30px"
                                : "20px",
                        }}
                    >
                        {/* <Row
                            justify={
                                !Object.keys(storeName).length
                                    ? "end"
                                    : "center"
                            }
                        >
                            <Col
                                xl={!Object.keys(storeName)?.length ? 8 : 4}
                            >
                                <AiOutlineTwitter color="white" size="25" />
                            </Col>
                            <Col
                                xl={!Object.keys(storeName)?.length ? 8 : 4}
                            >
                                <FaFacebookF color="white" size="25" />
                            </Col>
                            <Col
                                xl={!Object.keys(storeName)?.length ? 8 : 4}
                            >
                                <FaInstagram color="white" size="25" />
                            </Col>
                        </Row> */}
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
